import {SET_CLINIC_ID} from '../actions/clinic';

const initialState = {
  id: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CLINIC_ID:
      return {...state, id: action.payload.id};
    default:
      return state;
  }
};

export const selectClinicId = (state) => state.clinic.id;
